import React from 'react';

const SmallScreenNotice = () => {
  return (
    <div className="small-screen-notice">
      <div className="small-screen-notice-icon">🖥️</div>
      <h2>Best viewed on a larger screen</h2>
      <p>
        This Crypto Terminal is designed for laptops, desktops, and tablets.
        For the best experience, Please switch to a device with a larger screen.
      </p>
      <p>
        Your current device may not be fully compatible.
      </p>
    </div>
  );
};

export default SmallScreenNotice;
